import { useSyncExternalStore } from "react";

import {
  getCurrentUserSnapshot,
  subscribeToCurrentUser,
} from "@services/auth/currentUser";

// Re-renders when the profile changes in this tab (sign-in, picture upload) or another (logout).
export const useCurrentUser = () =>
  useSyncExternalStore(subscribeToCurrentUser, getCurrentUserSnapshot);
